import { render, staticRenderFns } from "./AddUnitOfMeasurePage.vue?vue&type=template&id=0ec08e50"
import script from "./AddUnitOfMeasurePage.vue?vue&type=script&lang=js"
export * from "./AddUnitOfMeasurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports